// This file holds all shared rich-text-editor-related utility methods going forward, per review feedback.

/**
 * Checks whether HTML content from a rich text editor is effectively empty —
 * i.e. it has no visible text and no embedded images.
 *
 * @param value - The HTML string to check
 * @returns true if the content has no meaningful text or image content
 *
 * @example
 * isRichTextContentEmpty('<p></p>'); // true
 * isRichTextContentEmpty('<p>Hello</p>'); // false
 * isRichTextContentEmpty('<p><img src="x.png" /></p>'); // false
 */
export function isRichTextContentEmpty(value: string): boolean {
  const container = document.createElement('div');
  container.innerHTML = value || '';

  const text = container.textContent?.trim() || '';
  const hasImage = container.querySelector('img') !== null;

  return text.length === 0 && !hasImage;
}
